import { API } from "../lib/api";

/**
 * Admin panel section: download + install the TerminalValue Chrome extension
 * (Grammarly-style Personal Terminal sidebar). The extension is an unpacked
 * Manifest V3 build — Chrome can't auto-install it, so we hand the admin a zip
 * and the load-unpacked steps.
 */
const STEPS = [
  "Download the zip above and unzip it (you'll get a 'terminalvalue-extension' folder).",
  "Open chrome://extensions in Chrome (or Edge/Brave).",
  "Toggle Developer mode ON (top-right).",
  "Click 'Load unpacked' and select the unzipped 'terminalvalue-extension' folder.",
  "Pin the TerminalValue icon (puzzle-piece menu → pin), then click it — or the '>_ terminal' edge tab — on any page.",
];

export default function AdminExtension() {
  const downloadUrl = `${API}/extension/download`;
  return (
    <div className="max-w-2xl text-[13px]" data-testid="admin-extension">
      <div className="border border-black">
        <div className="bg-black text-white px-3 py-2 font-bold">
          {">_"} chrome extension — personal terminal sidebar
        </div>
        <div className="p-3 space-y-4">
          <p className="text-[#333] leading-relaxed">
            A persistent right-edge sidebar (like Grammarly) that injects your
            Personal Terminal into any webpage. It auto-loads your latest
            terminal from your signed-in session, detects{" "}
            <span className="font-bold">$TICKER</span> symbols on the page, and
            lets you query the AI Concierge inline.
          </p>

          <a
            href={downloadUrl}
            className="tv-btn inline-block no-underline"
            data-testid="extension-download-btn"
          >
            [↓] download extension (.zip)
          </a>

          <div>
            <div className="text-[11px] uppercase tracking-wide text-[#888] mb-1">
              install (load unpacked)
            </div>
            <ol className="list-decimal pl-5 space-y-1 text-[#333]">
              {STEPS.map((s, i) => (
                <li key={i} data-testid={`extension-step-${i}`}>
                  {s}
                </li>
              ))}
            </ol>
          </div>

          <div className="border-t border-[#ddd] pt-3 text-[12px] text-[#555] leading-relaxed">
            <span className="font-bold">Note:</span> to auto-load your terminal,
            sign in with Google here in the admin (the panel above), then build a
            terminal via the Concierge. The sidebar talks to{" "}
            <span className="font-mono">terminalvalue.io</span> and uses your
            first-party session cookie. The AI ask + ticker chips work even when
            signed out.
          </div>
        </div>
      </div>
    </div>
  );
}
